module.exports = __webpack_public_path__ + "img/learn-more-illu-pickup-truck.998b8442.svg";